import { render, staticRenderFns } from "./TaxaPodFetestiNavigation.vue?vue&type=template&id=70567e0d&scoped=true"
import script from "./TaxaPodFetestiNavigation.vue?vue&type=script&lang=js"
export * from "./TaxaPodFetestiNavigation.vue?vue&type=script&lang=js"
import style0 from "./TaxaPodFetestiNavigation.vue?vue&type=style&index=0&id=70567e0d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70567e0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70567e0d')) {
      api.createRecord('70567e0d', component.options)
    } else {
      api.reload('70567e0d', component.options)
    }
    module.hot.accept("./TaxaPodFetestiNavigation.vue?vue&type=template&id=70567e0d&scoped=true", function () {
      api.rerender('70567e0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaxaPodFetestiNavigation.vue"
export default component.exports